import { Component, Input, OnInit } from '@angular/core';
import { AlertController, NavController, NavParams } from 'ionic-angular';

import { Product, ProductFav } from '../../models/product';
import { DataProvider } from '../../providers/data';
import { AppSettings } from '../../app/app.settings';
import { TranslateService } from "@ngx-translate/core";
import { Tools } from "../../tools/tools";
import { FavouriteDetailedPage } from "../favourites/favourite-detailed";
import { InAppBrowser } from '@ionic-native/in-app-browser';

@Component({
  selector: 'page-favourites-group',
  templateUrl: 'favourites-group.html',
})
export class FavouritesGroupPage implements OnInit {
  @Input() productIds: number[];
  @Input() type: string;

  public products: Product[] = [];
  public isLastProduct: boolean = false;

  public curCountry: string;

  public groupName: string = "";

  // get groupName(): string {
  //   //let zone = this.type === 'care' ? ('_' + (localStorage.getItem('es-zone') || 'face')) : '';      
  //   return ('TYPE_' + this.type /*+ zone*/).toUpperCase();
  // }  

  get currentLang() {
    let lang = localStorage.getItem('es-language') || AppSettings.DEFAULT_LANGUAGE;

    if (this.curCountry === 'uk') {
      lang = 'en';
    }
    return lang;
  }

  // public isCurrentProductFav(productId: number): boolean {
  //   let favProds: ProductFav[] = this.dataService.getFavProducts();
  //   return favProds.map(p => p.id).indexOf(productId) !== -1;
  // }

  // public swiperConfig: Object = {
  //     slidesPerView: 'auto',
  //     width: 680,
  //     onReachEnd: (swiper) => swiper.slideTo(0),
  //     onSlideChangeEnd: (swiper) => this.isLastProduct = swiper.activeIndex >= this.products.length - 2
  // };


  constructor(private iab: InAppBrowser,
              public navCtrl: NavController,
              public navParams: NavParams,
              private dataService: DataProvider,
              private translate: TranslateService,
              public alertCtrl: AlertController/*, private analyticsService: AnalyticsService*/) {
    this.curCountry = dataService.CURRENT_COUNTRY;
  }

  ngOnInit() {
    let group = ('TYPE_' + this.type).toUpperCase();
    let zone = '_' + (localStorage.getItem('es-zone') || '').toUpperCase();

    this.translate.get(group + zone).subscribe((res1: string) => {
      if (res1 && res1 !== group + zone) {
        this.groupName = res1;
      }
      else {
        this.translate.get(group).subscribe((res2: string) => {
          this.groupName = res2;
        });
      }
    });

    this.refreshProducts();
  }

  private refreshProducts() {
    //let favProdsIdsOfType: number[] = this.dataService.getFavProducts().filter(p => p.type === this.type).map(p => p.id);
    this.dataService.getProductsByIDs(this.productIds)
      .subscribe(productsData => {

        if (!AppSettings.CONFIG.show_all_volumes) {
          let groupByObj: any = Tools.groupBy(productsData, 'product_id');
          let productIDs = Object.getOwnPropertyNames(groupByObj);

          for (let productId of productIDs) {
            let sameProdVersions: Product[] = groupByObj[productId]
              .filter(v => v.volume && parseFloat(v.volume))
              .sort((p1, p2) => {
                let volume1 = parseFloat(p1.volume.replace(',', '.'));
                let volume2 = parseFloat(p2.volume.replace(',', '.'));
                if (volume1 > volume2) return 1;
                if (volume1 < volume2) return -1;
                return 0;
              });
            if (sameProdVersions.length > 1) {
              let currentVolume = sameProdVersions[0].volume;
              //console.log(sameProdVersions);                            
              for (let prodVersion of sameProdVersions) {
                if (prodVersion.volume !== currentVolume) {
                  let index = productsData.indexOf(prodVersion);
                  productsData.splice(index, 1);
                }
              }
            }
          }
        }       

        this.dataService.getProductsExtByIDs(productsData.map(p => p.id)).subscribe(productsExtData => {
          for (let product of productsData) {
            let extProducts = productsExtData.filter(p => p.id === product.id);
            if (extProducts.length > 0) {
              product.productExt = extProducts[0];
            }
          }
          this.products = productsData;
        });
      });
  }

  public getProductName(currentProduct: Product): string {
    return currentProduct['name_' + this.currentLang] || currentProduct['name'] || "";
  }

  public getProductUrlBuy(currentProduct: Product): string {
    return currentProduct['name_' + this.currentLang] || currentProduct['name'] || "";
  }

  public getProductBenefits(currentProduct: Product): string[] {
    //let benefitsCount = currentProduct['benefits_' + this.currentLang + '_take'] || currentProduct['benefits_take'];
    let benefitsStr = currentProduct['benefits_' + this.currentLang] || currentProduct['benefits'] || "";
    return benefitsStr ? benefitsStr.trim().split('\n').slice(0, 3) : [];
  }

  public openDetailedProductInfo(productId: number) {
    this.navCtrl.push(FavouriteDetailedPage, { type: this.type, id: productId });
    //this.router.navigate(['/product', /*this.productIds.join(','),*/this.type, productId]);
  }

  public confirmRemoveFavProduct(productId: number) {
    let mainThis = this;
    let alert = this.alertCtrl.create({
      title: 'Сonfirmation',
      message: 'Remove product from favourites?',
      buttons: [
        {
          text: 'Cancel',
          handler: () => { }
        },
        {
          text: 'Yes',
          handler: () => {
            mainThis.removeFavProduct(productId);
          }
        }
      ]
    });

    alert.present();
  }

  private removeFavProduct(productId: number) {
    let favProds: ProductFav[] = this.dataService.getFavProducts();
    let currProdIndex = favProds.map(p => p.id).indexOf(productId);
    if (currProdIndex !== -1) {
      favProds.splice(currProdIndex, 1);
    }
    let currProdIdIndex = this.productIds.indexOf(productId);
    if (currProdIdIndex !== -1) {
      this.productIds.splice(currProdIdIndex, 1);
    }
    this.dataService.setFavProducts(favProds);
    this.refreshProducts();
  }

  public openUrl(url: any) {
    const browser = this.iab.create(url);
    browser.show();
  }
}



// WEBPACK FOOTER //
// ./src/pages/favourites/favourites-group.ts